
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.426 4.623c-.315-.404-.84-.665-1.426-.665l-9.625.008c-.962 0-1.75.705-1.75 1.576v7.916c0 .871.788 1.576 1.75 1.576l9.625.008c.586 0 1.111-.262 1.426-.665L19.25 9.5l-3.824-4.877z","fill":"#0867B7"}}),_c('path',{attrs:{"d":"M6.406 12a1.3 1.3 0 01-.11-.332c-.211.267-.507.4-.888.4-.348 0-.645-.104-.888-.314a1.011 1.011 0 01-.366-.796c0-.402.148-.705.444-.91.296-.205.727-.307 1.292-.307h.356v-.195c0-.34-.147-.51-.441-.51-.274 0-.41.135-.41.404H4.243c0-.358.151-.648.454-.872.306-.223.694-.335 1.166-.335.471 0 .844.115 1.117.346.274.23.414.545.42.946v1.638c.005.34.058.599.158.779V12H6.406zm-.72-.752c.143 0 .261-.03.355-.092a.576.576 0 00.205-.209v-.591H5.91c-.401 0-.602.18-.602.54 0 .105.035.19.106.256.07.064.16.096.27.096zm6.14-1.066c0 .606-.126 1.072-.377 1.398-.25.325-.604.488-1.06.488-.375 0-.678-.149-.909-.447L9.433 12H8.4V6.75h1.152V8.6c.214-.245.491-.367.83-.367.461 0 .816.166 1.067.496.25.33.376.795.376 1.395v.058zm-1.156-.072c0-.356-.048-.609-.144-.759a.473.473 0 00-.434-.229c-.26 0-.44.1-.54.297v1.47c.098.196.28.294.547.294.271 0 .443-.132.516-.396.037-.13.055-.356.055-.677zm3.58 1.07c.162 0 .287-.044.376-.13a.489.489 0 00.13-.37h1.08c0 .406-.146.739-.438.999-.29.26-.663.39-1.12.39-.539 0-.962-.17-1.272-.507-.31-.337-.465-.804-.465-1.4v-.049c0-.373.068-.703.205-.988.139-.287.338-.507.598-.66.26-.154.567-.232.923-.232.48 0 .862.134 1.145.4.282.267.424.628.424 1.084h-1.08c0-.192-.047-.339-.14-.441a.484.484 0 00-.376-.154c-.299 0-.473.19-.523.57-.016.122-.024.288-.024.5 0 .371.044.629.133.772.089.144.23.216.424.216z","fill":"#fff"}})])
          )
        }
      }
    